import { toastMutationStatus } from "@/common/helpers/toast-mutation-status";

interface ToastMessages {
  success: string;
  error: string;
  customErrors?: Record<number, string>;
}

/**
 * Handles form submission with standardized error handling and toast notifications
 * @param mutationFn - The async mutation function to execute
 * @param messages - Toast messages for success and error states
 * @param onSuccess - Callback executed on successful submission
 */
export async function handleFormSubmission<T>(
  mutationFn: () => Promise<T>,
  messages: ToastMessages,
  onSuccess?: () => void,
): Promise<void> {
  try {
    await toastMutationStatus({
      mutationFn,
      successMessage: messages.success,
      errorMessage: messages.error,
      customErrors: messages.customErrors,
      onSuccess,
    });
  } catch {
    return;
  }
}
